/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import kebabCase from 'lodash/fp/kebabCase.js';
import pick from 'lodash/fp/pick.js';

/*
Builds the model page url for a section. This is the single source of truth for section urls:
Router.jsx registers its routes from it (via pathFromSection), the sidebar links to it, and the
model types constant resolves each type's post-submit redirect target with it. Deriving all three
from one function is what keeps a configured redirect target from pointing at a url the router
never registered.
 */
const urlFromSection = section => {
  const { id, group } = pick(['id', 'group'], section);
  return id ? `${kebabCase(group)}/${kebabCase(id)}` : undefined;
};

export default urlFromSection;
